import "./infonavbar.css"

import React from "react"
import { Link } from "react-router-dom";
import {BiArrowBack} from 'react-icons/bi';

const InfoNavbar = () => {

    return(
        <div className="secnav__infonavbar">
          <div className="secnav__navbar__backhome">
          <Link to="/" style={{ textDecoration: 'none',color:"#000" }}><BiArrowBack size={20}/> BACK TO HOME</Link>
          </div>
        </div>
    );
};


export default InfoNavbar;